<template>
  <div class="news">
    <div class="top">
      <div class="left">{{ $t('home.newsCenter') }}</div>
      <div class="right">
        <div class="up"></div>
        <div class="mid" @click="navigateTo('/newsCenter')">
          <div class="txt">{{ $t('news.viewMore') }}</div>
          <img src="@/assets/img/right.png" alt="" />
        </div>
        <div class="down"></div>
      </div>
    </div>
    <div class="news_item">
      <div class="box" data-aos="zoom-in-up" v-for="(item, index) in state.imgs" :key="index" @mouseover="onMouseover(index)" @click="toNews(index)">
        <div :class="state.active==index?'overlay':''"></div>
        <img :src="item.imgSrc" alt="背景图片" v-if="state.active==index" />
        <img :src="item.imgCover" alt="默认图片" v-else/>
        <span :class="state.active===index?'box_text':''">
          <div class="name pos" data-aos="fade-up">{{ item.name }}</div>
        <div class="title pos" data-aos="fade-up">{{ item.title }}</div>
        <div class="tip pos" data-aos="fade-up">{{ item.tip }}</div>
        <div class="time pos">
          <div class="left">
            <span>{{item.day}}</span> {{ item.time }}
          </div>
          <div class="right">
            {{ $t('news.readMore') }}
            <img src="@/assets/img/news_right.png" alt="" />
          </div>
        </div>
        </span>
        </div>
    </div>
  </div>
</template>

<script setup>
import { reactive,onMounted,computed } from 'vue'
const { $aos } = useNuxtApp()
const { t, tm, rt } = useI18n()
const newsItems = computed(() => tm('news.items'))
const state = reactive({
  active: 0,
  imgs: computed(() => newsItems.value.map((item, index) => ({
    name: t('news.category'),
    title: rt(item.title),
    tip: rt(item.tip),
    imgSrc: `./n${index + 1}.png`,
    imgCover: './news_bg.png',
    time: rt(item.time),
    day: item.day
  })))
})
const onMouseover =(index)=>{
  state.active = index
}
const toNews=(index)=>{
  if(index===0){
    navigateTo(`/detail/${3}`)
  }else if(index===1){
    navigateTo(`/detail/${4}`)
  }else{
    navigateTo(`/detail/${5}`)
  }
}
onMounted(()=>{
  $aos().init({
    easing: 'ease-out-back',
    duration: 1200,
  })
})
</script>

<style lang="less" scoped>
.news {
  .top {
    padding-top: 61px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 0 -90px;
    .left {
      font-size: 14px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #333333;
    }
    .right {
      cursor: pointer;
      .up {
        width: 59px;
        height: 1px;
        background: #00a0e9;
      }
      .mid {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 5px 0;
        transition: transform 0.3s;
        &:hover {
          transform: translateX(10px);
          img{
            transform: translateX(3px);
          }
        }
        .txt {
          margin-right: -3px;
          color: #00a0e9;
        }
        img {
          width: 16px;
          height: 8px;
        }
      }
      .down {
        width: 59px;
        height: 1px;
        background: #00a0e9;
      }
    }
  }
  .news_item {
    display: flex;
    justify-content: space-around;
    margin: 0 100px;
    margin-top: 40px;
    .box {
          width: 158px;
          height: 200px;
          border-radius: 13px;
          overflow: hidden;
          cursor: pointer;
          position: relative;
          transition: box-shadow 0.3s;
        &:hover {
          img  {
        transform: scale(1.2); /* 鼠标经过时放大图片 */
      }
       }
         .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transition: background-color,opacity 1s ease; /* 添加过渡效果 */
          }
          img {
          width: 102%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease; /* 添加过渡效果 */
        }
    }
    .box_text {
     color: #fff;
    }
    .box .overlay {
      background-color: rgba(0, 160, 233, 1);
      opacity: 0.8;
      z-index: 9;
    }
    .pos{
      position: absolute;
      left: 15px;
    }
    .name {
      top: 20px;
      z-index: 10;
    }
    .title {
      font-size: 8px;
      top: 40px;
      font-weight: bold;
      z-index: 10;
    }
    .tip {
      top: 55px;
      z-index: 10;
      opacity: 0.8;
    }
    .time{
      bottom: 20px;
      display: flex;
      align-items: center;
      z-index: 10;
      .left{
        margin-right: 50px;
        span{
          font-size: 12px;
        }
      }
      .right{
        text-align: right;
        img{
          width: 8px;
          height: 5px;
        }
      }
    }
  }
}
</style>
